import React, { useContext } from "react";
import magnifyingGlassIcon from "../../../assets/images/magnifying-glass.svg";
import { PageContext } from "../../../context/PageContext";
import { SiteSettingsContext } from "../../../context/SiteSettingsContext";
import useTranslations from "../../../hooks/useTranslations";
import { ToolNavigationItem } from "../../../models/navigation/ToolNavigationItem";
import SanityLink from "../../SanityLink";

interface Props extends ToolNavigationItem {
  fontClass: string;
}

export const SearchToolLink = (props: Props) => {
  const translations = useTranslations();
  const { i18nLang } = useContext(PageContext);
  const { routeInfo } = useContext(SiteSettingsContext);

  return (
    <SanityLink
      className={`${props.fontClass} inline-flex justify-between items-center text-inherit font-bold no-underline focus:shadow-outline focus:outline-none rounded-sm`}
      reference={{
        i18nLang,
        slug: {
          current: routeInfo?.search?.slug?.current ?? ""
        }
      }}
    >
      <span className="order-2 ml-1">{translations.searchSubmit}</span>
      <svg width={14} height={14} className="fill-current order-1">
        <use xlinkHref={magnifyingGlassIcon.url} />
      </svg>
    </SanityLink>
  );
};

